import type { SubscriptionButtonProps } from "@product/scmp-sdk";
import dynamic from "next/dynamic";

export const DynamicSubscriptionButton = dynamic<SubscriptionButtonProps>(() =>
  import("@product/scmp-sdk").then(module => module.SubscriptionButton),
);
